module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/cyclebar-8856d2021591cf285dd019883fb17ad3.png";